import { render, staticRenderFns } from "./richtext.vue?vue&type=template&id=5921a418&scoped=true&"
import script from "./richtext.vue?vue&type=script&lang=js&"
export * from "./richtext.vue?vue&type=script&lang=js&"
import style0 from "./richtext.vue?vue&type=style&index=0&id=5921a418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921a418",
  null
  
)

export default component.exports